import React from 'react'
import { Logo } from '../../assests/ExportImageIcon'
import './HotelSearchLoader.css'

const WINDOW_COLS = [15, 37, 59, 81]
const WINDOW_ROWS = [40, 66, 92, 118]
const WINDOWS = WINDOW_ROWS.flatMap((y, rowIndex) =>
    WINDOW_COLS.map((x, colIndex) => ({
        x,
        y,
        begin: `${((rowIndex * WINDOW_COLS.length + colIndex) * 0.14).toFixed(2)}s`,
    }))
)

const HotelBuildingIcon = () => (
    <svg viewBox="-20 -34 149 226" className='hotelSearchLoader__buildingSvg'>
        <defs>
            <linearGradient id="hotelSearchLoaderBody" x1="0" y1="0" x2="0" y2="174" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#1a9b6e" />
                <stop offset="1" stopColor="#0f6b4f" />
            </linearGradient>
            <linearGradient id="hotelSearchLoaderSign" x1="0" y1="0" x2="109" y2="0" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#f0c04a" />
                <stop offset="1" stopColor="#b8860b" />
            </linearGradient>
        </defs>

        <ellipse className='hotelSearchLoader__shadow' cx="54.5" cy="180" rx="58" ry="7" fill="#0d5940" />

        <circle className='hotelSearchLoader__sparkle hotelSearchLoader__sparkle--s1' cx="76" cy="-22" r="2" fill="#f0c04a" />
        <circle className='hotelSearchLoader__sparkle hotelSearchLoader__sparkle--s2' cx="86" cy="-10" r="1.5" fill="#f0c04a" />
        <circle className='hotelSearchLoader__sparkle hotelSearchLoader__sparkle--s3' cx="72" cy="-2" r="1.6" fill="#f0c04a" />

        <rect x="0" y="26" width="109" height="148" rx="4" fill="url(#hotelSearchLoaderBody)" />
        <rect x="-4" y="20" width="117" height="8" rx="3" fill="#0f6b4f" />

        <rect x="20.71" y="0" width="67.58" height="18" rx="3" fill="url(#hotelSearchLoaderSign)">
            <animate attributeName="opacity" values="0.75;1;0.75" dur="1.8s" repeatCount="indefinite" />
        </rect>
        <text x="54.5" y="13" textAnchor="middle" fontFamily="Segoe UI, sans-serif" fontSize="10" fontWeight="700" letterSpacing="2" fill="#ffffff">HOTEL</text>

        <line x1="54.5" y1="0" x2="54.5" y2="-16" stroke="#b8860b" strokeWidth="2" />
        <path d="M 54.5 -16 L 68.5 -12 L 54.5 -8 Z" fill="#1a9b6e" />

        {WINDOWS.map(({ x, y, begin }, index) => (
            <React.Fragment key={index}>
                <rect x={x} y={y} width="13" height="15" rx="2" fill="#eafaf1" opacity="0.9" />
                <rect x={x} y={y} width="13" height="15" rx="2" fill="#f0c04a">
                    <animate attributeName="opacity" values="0;0.95;0" dur="2.6s" begin={begin} repeatCount="indefinite" />
                </rect>
            </React.Fragment>
        ))}

        <path d="M 38.5 148 Q 54.5 136 70.5 148 Z" fill="url(#hotelSearchLoaderSign)" />

        <rect x="45.5" y="148" width="18" height="26" rx="3" fill="#eafaf1" />
        <line x1="54.5" y1="148" x2="54.5" y2="174" stroke="#0f6b4f" strokeWidth="1.4" />
        <circle cx="60.5" cy="161" r="1.4" fill="#b8860b" />

        <g className='hotelSearchLoader__suitcase'>
            <rect x="20" y="160" width="16" height="13" rx="2" fill="url(#hotelSearchLoaderSign)" />
            <rect x="25.5" y="156" width="5" height="5" rx="1.5" fill="none" stroke="#b8860b" strokeWidth="1.6" />
            <line x1="28" y1="163" x2="28" y2="170" stroke="#0f6b4f" strokeWidth="1" />
        </g>
    </svg>
)

const HotelSearchLoader = ({ text = 'Finding the best hotels for you', size = 'default' }) => {
    return (
        <div className={`hotelSearchLoader ${size === 'compact' ? 'hotelSearchLoader--compact' : ''}`}>
            <div className='hotelSearchLoader__logoCircle'>
                <img src={Logo} alt='' />
            </div>

            <div className='hotelSearchLoader__buildingWrap'>
                <HotelBuildingIcon />
            </div>

            {text && (
                <p className='hotelSearchLoader__text'>
                    {text}
                    <span className='hotelSearchLoader__dots'>
                        <span>.</span><span>.</span><span>.</span>
                    </span>
                </p>
            )}
        </div>
    )
}

export default HotelSearchLoader
